import React from 'react';

function Text(props) {
  const {
    value,
    label,
    removeUnderlines,
    decimalDigits,
    units,
    placeholder,
    mainWrapperClassName,
    textClassName,
    labelClassName,
    alwaysTextField,
    clickHandler,
  } = props;

  let updatedValue = value;

  if (typeof value !== 'object' || value === null) {
    if (updatedValue === undefined || updatedValue === null || updatedValue === '') updatedValue = placeholder;
    else if (removeUnderlines) updatedValue = updatedValue.toString().replace(/_/g, ' ');
    else if (isFinite(value) && !alwaysTextField)
      updatedValue = `${(+value).toFixed(decimalDigits || 0)} ${units || ''}`;
    else updatedValue = `${value} ${units || ''}`;
  } else {
    let valuesPresented = false;
    updatedValue = value.map((singleValue, index) => {
      if (singleValue === undefined || singleValue === null || singleValue === '') {
        return `${(0).toFixed(decimalDigits[index] || 0)} ${units[index] || ''}`;
      } else if (isFinite(singleValue)) {
        valuesPresented = true;
        return `${(+singleValue || 0).toFixed(decimalDigits[index] || 0)} ${units[index] || ''}`;
      } else {
        valuesPresented = true;
        return `${value} ${units[index] || ''}`;
      }
    });

    if (!valuesPresented) updatedValue = placeholder;
    else updatedValue = updatedValue.join(' and ');
  }

  return (
    <div className={`ect-text ${mainWrapperClassName}`}>
      <div className={labelClassName || 'label'}>{label.toString().replace(/_/g, ' ')}</div>
      <div
        className={`${textClassName || 'text'} ${clickHandler ? '_cursor_pointer' : ''}`}
        onClick={clickHandler}
      >
        {updatedValue}
      </div>
    </div>
  );
}

Text.defaultProps = {
  value: '',
  label: '',
  removeUnderlines: false,
  placeholder: 'N/A',
  alwaysTextField: false,
  clickHandler: undefined,
};

export default Text;



// WEBPACK FOOTER //
// ./src/app/Components/Text.jsx